import * as webserviceActions from './webserviceActions'

const actions = () => {
  return {
    ...webserviceActions
  }
}
export default actions;